import { takeEvery, put, fork, call, all, select } from 'redux-saga/effects';
import * as serviceSlice from './serviceSlice';
import * as uiSlice from '../../../UI/redux/uiSlice';
import { authReducerActions, authSagaActions } from '../../../Auth';
import { getAllServices } from './serviceAPI';


export function* onLoadServicesStartAsync(){

    try{
        
        yield put(serviceSlice.actions.startCall({ callType: serviceSlice.callTypes.list }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            key: auth.sessionKey
        };

        const response = yield call(getAllServices, reqBody);        

        if(response.status === 200){
            let totalCount = response.data.length;
            let services = response.data;
            
            yield put(serviceSlice.actions.servicesFetched({ totalCount, services }));
        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 403){

            yield put(authReducerActions.loggedOut());
            
        } else {
            let errorMsg = "There was an error retrieving service information.";

            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uiSlice.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uiSlice.actions.error({ status, msg }));

            }

            // yield put(uiSlice.actions.showNotification({
            //     status:"error",
            //     title:"Error",
            //     message: errorMsg
            // }));

            yield put(serviceSlice.actions.catchError({
                callType: serviceSlice.callTypes.list,
                error: errorMsg
            }));
        }
    }

};

export const actionTypes = {
    FetchServices: "[FetchServices] Fetch Services API Action"
  };

export const actions = {

    fetchServices: () => ({ type: actionTypes.FetchServices, payload: { undefined } })
  
};

export function* fetchServices(){

    yield takeEvery(actionTypes.FetchServices, onLoadServicesStartAsync);    
};


const fSagas = [fork(fetchServices)];

export function* saga(){
    yield all ([...fSagas]);
};
